import { useEffect, useState } from 'react';

const estilosVariante = {
  info: {
    borde: '#2563eb',
    fondo: '#eff6ff',
    texto: '#1d4ed8',
    boton: 'btn btn-primary'
  },
  warning: {
    borde: '#f59e0b',
    fondo: '#fffbeb',
    texto: '#92400e',
    boton: 'btn btn-warning'
  },
  danger: {
    borde: '#dc2626',
    fondo: '#fef2f2',
    texto: '#991b1b',
    boton: 'btn btn-danger'
  },
  success: {
    borde: '#16a34a',
    fondo: '#f0fdf4',
    texto: '#166534',
    boton: 'btn btn-success'
  }
};

export default function AppModal({
  abierto,
  titulo,
  mensaje,
  variante = 'info',
  mostrarInput = false,
  inputLabel = 'Motivo',
  inputPlaceholder = '',
  inputValorInicial = '',
  textoCancelar = 'Cancelar',
  textoAceptar = 'Aceptar',
  mostrarCancelar = true,
  aceptando = false,
  onCancelar,
  onAceptar
}) {
  const [valorInput, setValorInput] = useState(inputValorInicial);
  const estiloVariante = estilosVariante[variante] || estilosVariante.info;

  useEffect(() => {
    if (abierto) {
      setValorInput(inputValorInicial);
    }
  }, [abierto, inputValorInicial]);

  useEffect(() => {
    if (!abierto) return undefined;

    function cerrarConEscape(event) {
      if (event.key === 'Escape' && !aceptando) {
        onCancelar?.();
      }
    }

    window.addEventListener('keydown', cerrarConEscape);

    return () => {
      window.removeEventListener('keydown', cerrarConEscape);
    };
  }, [abierto, aceptando, onCancelar]);

  if (!abierto) return null;

  function aceptar(event) {
    event.preventDefault();
    onAceptar?.(mostrarInput ? valorInput : undefined);
  }

  return (
    <div
      style={styles.overlay}
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget && !aceptando) {
          onCancelar?.();
        }
      }}
    >
      <form
        style={{
          ...styles.modal,
          borderTopColor: estiloVariante.borde
        }}
        role="dialog"
        aria-modal="true"
        aria-labelledby="app-modal-titulo"
        onSubmit={aceptar}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div
          style={{
            ...styles.indicador,
            backgroundColor: estiloVariante.fondo,
            color: estiloVariante.texto
          }}
        >
          {variante === 'danger' || variante === 'warning' ? '!' : 'i'}
        </div>

        <div style={styles.contenido}>
          <h2 id="app-modal-titulo" style={styles.titulo}>
            {titulo}
          </h2>

          {mensaje && (
            <p style={styles.mensaje}>
              {mensaje}
            </p>
          )}

          {mostrarInput && (
            <div style={styles.campo}>
              <label className="form-label" htmlFor="app-modal-input">
                {inputLabel}
              </label>

              <textarea
                id="app-modal-input"
                className="form-control"
                rows="4"
                value={valorInput}
                placeholder={inputPlaceholder}
                disabled={aceptando}
                autoFocus
                onChange={(event) => setValorInput(event.target.value)}
                style={styles.input}
              />
            </div>
          )}
        </div>

        <div style={styles.acciones}>
          {mostrarCancelar && (
            <button
              className="btn btn-outline-secondary"
              type="button"
              disabled={aceptando}
              onClick={onCancelar}
            >
              {textoCancelar}
            </button>
          )}

          <button
            className={estiloVariante.boton}
            type="submit"
            disabled={aceptando}
          >
            {aceptando ? 'Procesando...' : textoAceptar}
          </button>
        </div>
      </form>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    zIndex: 1080,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '18px',
    background: 'rgba(15, 23, 42, 0.42)'
  },
  modal: {
    width: 'min(100%, 460px)',
    background: '#ffffff',
    border: '1px solid #d9dee7',
    borderTop: '4px solid',
    borderRadius: '10px',
    boxShadow: '0 20px 45px rgba(15, 23, 42, 0.18)',
    padding: '18px 20px',
    boxSizing: 'border-box'
  },
  indicador: {
    width: '34px',
    height: '34px',
    borderRadius: '999px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 800,
    marginBottom: '12px'
  },
  contenido: {
    minWidth: 0
  },
  titulo: {
    margin: 0,
    color: '#111827',
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: 1.25
  },
  mensaje: {
    margin: '8px 0 0',
    color: '#4b5563',
    fontSize: '13px',
    lineHeight: 1.45
  },
  campo: {
    marginTop: '14px'
  },
  input: {
    resize: 'vertical',
    minHeight: '92px',
    fontSize: '13px'
  },
  acciones: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
    marginTop: '16px',
    flexWrap: 'wrap'
  }
};
